import api from '@/services/api'

const getUsers = async params => {
    try {
        const resp = await api.get('/users', {
            params: {
                ...params,
                orderBy: 'name',
                filter: 'id;name;picture;occupation',
                search: `has_talk:1;` + params.search,
                searchFields: 'name:like',
                and: 'yes',
            },
        })

        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}

export { getUsers }
